const Header = {
  el: {
    root: document.querySelector<HTMLElement>('.header'),
    nav: document.querySelector<HTMLElement>('.navigation'),
    logo: document.querySelector<HTMLElement>('.logo'),
    container: document.querySelector<HTMLElement>('.header__container'),
  },
  init() {
    if (this.el.nav) {
      // this.navigationion()
      // this.handleResize()
    }
  },

  navigation() {
    this.el.nav.style.width = `${this.el.container.clientWidth - this.el.logo.clientWidth}px`

    if (this.el.logo.clientWidth > 0) {
      // console.log('calculating nav');
      // console.log(this.el.container.clientWidth, this.el.logo.clientWidth);
      // console.log(this.el.container.clientWidth - this.el.logo.clientWidth);
    }
  },

  handleResize() {
    window.addEventListener('resize', () => {
      this.navigation()
    })
  },
}

export default Header
